import { createFileRoute } from "@tanstack/react-router";
import { StudioDetailPage } from "@/views/public/studios/StudioDetailPage.tsx";

export const Route = createFileRoute("/_public/studios/$number/")({
  component: StudioDetailPage,
});
